// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';
let i = 0;

// Assign individual classes to pagination and bullets for each instance of slider
//Pagination Bullets
const cardControls = document.querySelectorAll('.articles-controls');
for (i = 0; i < cardControls.length; i++) {
    cardControls[i].classList.add('articles-controls-' + i);
}

//Pagination Bullets
const paginationBullets = document.querySelectorAll('.articles-pagination');
for (i = 0; i < paginationBullets.length; i++) {
    paginationBullets[i].classList.add('articles-pagination-' + i);
}
//Pagination Arrow Next
const paginationNext = document.querySelectorAll('.articles-button-next');
for (i = 0; i < paginationNext.length; i++) {
    paginationNext[i].classList.add('articles-button-next-' + i);
}
//Pagination Arrow Prev
const paginationPrev = document.querySelectorAll('.articles-button-prev');
for (i = 0; i < paginationPrev.length; i++) {
    paginationPrev[i].classList.add('articles-button-prev-' + i);
}
//Swiper JS
const swiperSlider = document.querySelectorAll('.articles-swiper-container');
for( i=0; i< swiperSlider.length; i++ ) {
    swiperSlider[i].classList.add('articles-swiper-container-' + i);
    var slider = new Swiper('.articles-swiper-container-' + i, {
        a11y: {
            enabled: true
        },
        breakpointBase: 'window',
        slidesPerView:1.25,
        spaceBetween: 30,
        loop: false,
        breakpoints: {
            // when window width is >= 320px
            // when window width is >= 480px
            650: {
                slidesPerView: 2.5,
                spaceBetween: 30
            },
            // when window width is >= 640px
            1000: {
                slidesPerView: 3.4,
                spaceBetween: 30
            }
        },
        slideClass:'swiper-slide',
        navigation: {
            nextEl: '.articles-button-next-' + i + '',
            prevEl: '.articles-button-prev-' + i + '',
        },

        pagination: {
            el: '.articles-pagination-' + i + '',
            clickable: true,
        },


        on: {
            init: function () {
                if ($(window).width() <= 992) {
                    const nextButtonWidth = $('.articles-button-next-' + i).outerWidth();
                    const paginationWidth = $('.articles-pagination-' + i).outerWidth();

                    // Calculate the minimum width required for .articles-controls
                    const minTestimonialControlsWidth = nextButtonWidth + paginationWidth + 70;

                    // Set the minimum width to .articles-controls
                    $('.articles-controls-' + i).css('min-width', minTestimonialControlsWidth + 'px');
                }
            },
            resize: function () {
                // console.log($(window).width());
                if ($(window).width() <= 992) {
                    const nextButtonWidth = $('.articles-button-next-' + i).outerWidth();
                    const paginationWidth = $('.articles-pagination-' + i).outerWidth();

                    // Calculate the minimum width required for .articles-controls
                    const minTestimonialControlsWidth = nextButtonWidth + paginationWidth + 70;

                    // Set the minimum width to .articles-controls
                    $('.articles-controls-' + i).css('min-width', minTestimonialControlsWidth + 'px');
                }
            },
        },


    });
}

